import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'subtitleFormat';

export class SubtitleFormat extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
